import { useEffect } from "react";

const SITE_URL = "https://viallbusiness.com";
const DEFAULT_TITLE = "Viall Business Solutions | Employee Benefits & Small Business Insurance";
const DEFAULT_DESC = "Viall Business Solutions provides employee benefits and small business insurance in North Dakota. Dental, vision, group life, disability, and supplemental coverage built for small and mid size businesses.";

const setMeta = (name, content, attr = "name") => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * usePageMeta — Updates document title, meta description, OG tags, and canonical URL.
 * Call from each page component with its own SEO copy.
 */
export const usePageMeta = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const canonical = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:url", canonical, "property");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setLink("canonical", canonical);
  }, [title, description, path]);
};
